
/**
 * 工具箱相关
 * */

//工具箱
Vue.component(
    "tools",
    resolve => require(["../../components/Tools"], resolve)
);
Vue.component(
    'tools-top-adv',
    resolve => require(["../../components/adv/toolsTopAdv"], resolve)
)
Vue.component(
    'tools-right-adv',
    resolve => require(["../../components/adv/toolsRightAdv"], resolve)
)
Vue.component(
    'tools-left-adv',
    resolve => require(["../../components/adv/toolsLeftAdv"], resolve)
)
Vue.component(
    'tools-speed-bottom-adv',
    resolve => require(["../../components/adv/toolsSpeedBottomAdv"], resolve)
)

//Ping综合测速
Vue.component(
    "ping-table",
    resolve => require(["../../components/PingTable"], resolve)
);

//手机归属地查询
Vue.component(
    "phone-affiliation",
    resolve => require(["../../components/PhoneAffiliation"], resolve)
);

//IP查询
Vue.component(
    "ip-search",
    resolve => require(["../../components/ipSearch"], resolve)
);


//Ping测试
Vue.component(
    "ping-test",
    resolve => require(["../../components/pingTest"], resolve)
);

//更多工具选择页面
Vue.component(
    "more-tools-list",
    resolve => require(["../../components/tools/moreToolsList.vue"], resolve)
);

// 新增ip计算工具
Vue.component(
    "ipCalculator",
    resolve => require(["../../components/tools/ipCalculator/index.vue"], resolve)
);

//节点小宝专题页
Vue.component(
    "jdxb",
    resolve => require(["../../components/tools/jdxb.vue"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/tools.js